import React from "react";
import MainHeader from "../../components/common/MainHeader";
import { useTranslation } from "react-i18next";
import { URL_POST_BAKING } from "../../constance/urls";
import * as _ from 'lodash';
import { useHistory, useParams } from "react-router-dom";
import { GET, PUT } from "../../utils/HttpClient";
import { Toast } from "../../utils/Toast";
import { defaultPostBakingWasteWoodInputDetail } from "../../constance/dataTypes";
import ErrorMessage from "../../components/common/ErrorMessage";
import WasteWoodSizeAmountMapList from "../../components/post-baking-waste-wood-input/WasteWoodSizeAmountMapList";
import WasteWoodModal from "../../components/post-baking-waste-wood-input/WasteWoodModal";
import { Layout, Spin, Form, Button, DatePicker, Row, Space } from "antd";
import { Content } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import dayjs from "dayjs";
import { SaveFilled, PlusOutlined } from "@ant-design/icons";
import ColorButton from "../../components/common/ColorButton";
import { GREEN } from "../../constance/color";
import SubHeader from "../../components/common/SubHeader";

export default function PostBakingWasteWoodInputDetailView() {

  const history = useHistory();
  const { t } = useTranslation();
  const { id } = useParams();
  const [form] = Form.useForm();

  const ovenFormRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [inputTarget, setInputTarget] = React.useState(null);
  const [editable, setEditable] = React.useState(false);
  const [isDone, setIsDone] = React.useState(true);

  const handleSubmit = async (values) => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const requestData = {
        ...values,
        post_baking_group_date: values.post_baking_group_date?.format(DATE_FORMAT),
        input_date: values.input_date?.format(DATE_FORMAT),
      };

      const response = await GET(URL_POST_BAKING.CHECK_POST_BAKING_GROUP,
        { date: requestData.post_baking_group_date, ovens: requestData.ovens?.join(','), })

      if (!response.data.exists) {
        Toast.error(t('error'))
        setErrorMessages(t('post_baking_waste_wood_count.errors.no_wood'))
        return;
      }

      await PUT(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_TRANSACTION}${id}/`, requestData)
      fetchData();

      Toast.success(t('succes'))
    } catch (error) {
      Toast.error(t('error'))
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const fetchData = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_TRANSACTION}${id}/`)
      const data = response.data;

      form.setFieldsValue({
        ...data,
        post_baking_group_date: data.post_baking_group_date ? dayjs(data.post_baking_group_date) : null,
        input_date: data.input_date ? dayjs(data.input_date) : null,
      });
      setEditable(!data.interfaced);
      setIsDone(data.isDone)
      if (ovenFormRef.current) {
        ovenFormRef.current.initial(data.ovens || [])
      }
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id])

  return (
    <div>
      <Layout>
        <SubHeader />
        <Content style={{ margin: '24px' }}>
          <Title level={2}>{t('post_baking_waste_wood_input.detail')}</Title>
          <ErrorMessage message={errorMessages} length={100} />
          <Spin spinning={loading} tip={t('loading')} fullscreen />
          <Form form={form} initialValues={defaultPostBakingWasteWoodInputDetail} onFinish={handleSubmit}>
            <Row justify={'center'}>
              <Form.Item name={'barcode'} hidden />
              <Form.Item
                label={t('post_baking_waste_wood_count.group_date')}
                name={'post_baking_group_date'}
                rules={[{ required: true, message: t('error_messages.validation.required') }]}>
                <DatePicker
                  inputReadOnly={!editable}
                  format={HUMAN_DATE_FORMAT}
                  placeholder={t('post_baking_waste_wood_count.group_date')}
                  open={editable ? undefined : false}
                  allowClear={editable ? undefined : false}
                />
              </Form.Item>
            </Row>
            <Row justify={'center'}>
              <Form.Item
                label={t('post_baking_waste_wood_input.input_date')}
                name={'input_date'}
                rules={[{ required: true, message: t('error_messages.validation.required') }]}>
                <DatePicker
                  inputReadOnly={!editable}
                  format={HUMAN_DATE_FORMAT}
                  placeholder={t('post_baking_waste_wood_input.input_date')}
                  open={editable ? undefined : false}
                  allowClear={editable ? undefined : false}
                />
              </Form.Item>
            </Row>

            <WasteWoodSizeAmountMapList
              readOnly={!editable}
              dataList={form.getFieldValue("wood_size_amount_map_list") || []}
              onEdit={setInputTarget}
              fetchData={fetchData} />

            <Space direction="vertical" size={'large'}>
              {(!isDone && editable) &&
                <ColorButton
                  variant="outlined"
                  color="primary"
                  override={GREEN}
                  icon={<PlusOutlined />}
                  onClick={() => setInputTarget('add')} >{t('add')}</ColorButton>
              }

              <WasteWoodModal
                transaction={id}
                open={inputTarget != null}
                onClose={() => { setInputTarget(null); fetchData(); }}
                target={inputTarget} />

              <Space>
                {editable &&
                  <Button
                    type="primary"
                    loading={loading}
                    htmlType="submit"
                    icon={<SaveFilled />}>
                    {t('save')}
                  </Button>
                }
                <Button
                  variant="filled"
                  color="default"
                  onClick={() => history.goBack()}
                  loading={loading} >
                  {t('back')}
                </Button>
              </Space>
            </Space>
          </Form>

        </Content>
      </Layout>
    </div>
  )
}

